import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

$(document).ready(function(){
  // 下属单位
  var swiper1 = new Swiper(".section2 .sec-swiper .mySwiper", {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {//按钮
      nextEl: ".section2 .sec-swiper .swiper-button-next",
      prevEl: ".section2 .sec-swiper .swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2.5,
        spaceBetween: 20
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 40
      }
    },
  })
  var swiper2 = new Swiper(".section2 .desc-swiper .mySwiper", {
    allowTouchMove: false,
    effect : 'fade',
    // navigation: {//按钮
    //   nextEl: ".section2 .desc-swiper .swiper-button-next",
    //   prevEl: ".section2 .desc-swiper .swiper-button-prev",
    // },
  })

  let swipers = $('.section2 .desc-swiper .img-swiper');
  for(let i = 0; i < swipers.length; i++){
    new Swiper(swipers[i], {
      effect : 'fade',
      fadeEffect: {
        crossFade: true,
      },
      watchOverflow: true,
      navigation: {//按钮
        nextEl: $(swipers[i]).find('.swiper-button-next')[0],
        prevEl: $(swipers[i]).find('.swiper-button-prev')[0],
      },
    });
  }

  $('.section2 .sec-swiper .mySwiper .swiper-slide').on('click',function(){
    let index = $(this).index()
    $('.section2 .desc-swiper').addClass('show')
    swiper2.slideTo(index)
    $('body').css({
      'height':'100vh',
      'overflow-y':'hidden'
    })
  })
  $('.section2 .desc-swiper .close-btn').on('click',function(){
    $('.section2 .desc-swiper').removeClass('show')
    $('body').css({
      'height':'auto',
      'overflow-y':'auto'
    })
  })

  getsec3H()
})

$(window).resize(function(){
  getsec3H()
})

function getsec3H(){
  let paddingTop = $('.section3 .fixed-cont').css("padding-top")
  let paddingBtm = $('.section3 .fixed-cont').css("padding-bottom")
  let historyH = $('.section3 .cont ul').outerHeight() + parseInt(paddingTop.replace('px', '')) + parseInt(paddingBtm.replace('px', ''))
  
  $('.section3').css('height', historyH + 'px')
}

$(document).scroll(function () {
  let scroH = $(document).scrollTop(); //滚动高度
  let viewH = $(window).height(); //可见高度
  let contentH = $(document).height(); //内容高度
  let fixedTop = $('.section3').offset().top
  let fixedBtm = $('.section3').offset().top + $('.section3').outerHeight() - viewH

  if (scroH < fixedTop) {
    $('.section3').removeClass('fixed')
    $('.section3 .cont ul').css('transform','translateY(0px)')
  }else if (scroH > fixedTop && scroH < fixedBtm) {
    $('.section3').addClass('fixed').removeClass('abs')
    $('.section3 .cont ul').css('transform','translateY(-'+ (scroH-fixedTop) +'px)')
  }else{
    $('.section3').addClass('abs').removeClass('fixed')
    $('.section3 .cont ul').css('transform','translateY(-'+ (fixedBtm-scroH) +'px)')
  }
});